// Copyright 2020, J. Donald Tillman.  All rights reserved.
// Waveform Workbench app.
// The heavy lifting for the Waveform Workbench.

const fftN = 64;
const audN = fftN / 2;

const fftRe = new Float32Array(fftN);
const fftIm = new Float32Array(fftN);
const audRe = new Float32Array(audN);
const audIm = new Float32Array(audN);

let actx: null | AudioContext;
let osc: null | OscillatorNode;
let gain: null | GainNode;

export const updateWave = (waveform: number[], scope: any) => {
    // pluck the samples for the FFT
    var skip =  waveform.length / fftN;
    for (let i = 0; i < fftN; i++) {
	fftRe[i] =  waveform[skip * i];
	fftIm[i] = 0.0;
    }
    fft(fftRe, fftIm);

    // audio:
    for (let i = 0; i < audN; i++) {
        audRe[i] = fftRe[i];
        audIm[i] = fftIm[i];
    }
    if (actx && osc) {
	osc.setPeriodicWave(
	    actx.createPeriodicWave(audRe, audIm,
                                    {disableNormalization: true}));
    }
    scope.plot(waveform, fftRe, fftIm);
};

export const initAudio = () => {
    if (actx) {
        return;
    }
    // sheeshe
    actx = new (window['AudioContext'] ||  window['webkitAudioContext'])();
    osc = actx.createOscillator();
    osc.setPeriodicWave(
	actx.createPeriodicWave(audRe, audIm,
                                {disableNormalization: true}));
    gain = actx.createGain();
    gain.connect(actx.destination);
    osc.connect(gain);
    osc.start();
};

export const setFreq = (f) => 
    actx && osc && osc.frequency.setValueAtTime(f, actx.currentTime);


// 0 to 1
export const setGain = vol => 
    actx && gain && gain.gain.setValueAtTime(0.3 * vol, actx.currentTime);


// adapted from:
//    http://antimatter15.com/2015/05/cooley-tukey-fft-dct-idct-in-under-1k-of-javascript/
// (cuz I'm so not in the mood to do it from scratch)
// operates on re, im in place
export const fft = (re, im) => {
    const n = re.length;
    for (let i = 0; i < n; i++) {
        let j, h, k;
        // eslint-disable-next-line
        for(j = 0, h = i, k = n; k >>= 1; h >>= 1) {
            j = (j << 1) | (h & 1);
	}
        if (j > i) {
	    let t = re[i];
        re[i] = re[j];
        re[j] = t;
	    t = im[i];
	    im[i] = im[j];
	    im[j] = t;
        }
    }
    for (let hN = 1; hN * 2 <= n; hN *= 2) {
        for (let i = 0; i < n; i += hN * 2) {
            for (let j = i; j < i + hN; j++) {
                const cos = Math.cos(Math.PI * (j - i) / hN);
                const sin = Math.sin(Math.PI * (j - i) / hN);
                const tre =  re[j + hN] * cos + im[j + hN] * sin;
                const tim = -re[j + hN] * sin + im[j + hN] * cos;
                re[j + hN] = re[j] - tre;
		im[j + hN] = im[j] - tim;
                re[j] += tre;
		im[j] += tim;
            }
	}
    }
    // tweaking is necessary, not sure why
    const fix = 2 / n;
    for (let i = 0; i < n; i++) {
	re[i] *= fix;
	im[i] *= -fix;
    }
};

